import { CommonModule } from '@angular/common';
import { 
  ChangeDetectionStrategy, 
  Component, 
  OnInit 
} from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { NavSignalsService } from '../../services/nav.signals.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { environment } from '@environments/environment';
import { Router, RouterModule } from '@angular/router';
import { SignalsService } from '@shared/services/signals/signals.service';
import { Subject } from 'rxjs';
import { PopoverModule } from 'primeng/popover';
import { CrewDetail } from 'app/features/flights/flight-detail/model/crew-detail';
import { AdminService } from 'app/features/admin/admin.service';
import { AppService } from 'app/app.service';
import { BadgeModule } from 'primeng/badge';

@Component({
    selector: 'app-main',
    imports: [
        CommonModule,
        StyleClassModule,
        NavMenuComponent,
        RouterModule,
        PopoverModule,
        BadgeModule
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent implements OnInit {

  version: string = environment.appVersion;
  sidebarMaskVisible = this.navSignalsService.sidebarMaskVisible$;
  isAcitveEmpNumAdmin = this.signalService.isEumulatingEmpNumActive$();
  emulatedPilot?: CrewDetail;
  destroy$ = new Subject<void>();
  //theme = this.appService.getTheme();

  constructor(
    public navSignalsService: NavSignalsService,
    public signalService: SignalsService,
    private adminService: AdminService,
    public appService: AppService,
    private route: Router
  ) {}


  ngOnInit(): void {
    this.sidebarMaskVisible.set(false);
  }

  //If Admin get emulated pilot info
  getEmulatedPilotInfo(): void {
    const emulatedPilot = localStorage.getItem('emulatedPilot');
    if (emulatedPilot) {
      const _emulatedPilot = JSON.parse(emulatedPilot);
      this.emulatedPilot = _emulatedPilot.response[0];
    }
  }

  //Reset emulation and return to own account
  resetEmulatedPilot(){
    this.adminService.resetEmulatedPilot();
    this.route.navigate(['/flights']);
  }

  toggleSidebarMask(): void {
    this.sidebarMaskVisible.set(!this.sidebarMaskVisible());
  }

}
